import React from "react";
import "../../landing.css";
import localeText from "../../../../locale";

const steps = [
  { icon: "pi pi-map-marker", title: "lp2EcoStep1Title", description: "lp2EcoStep1Desc" },
  { icon: "pi pi-chart-line", title: "lp2EcoStep2Title", description: "lp2EcoStep2Desc" },
  { icon: "pi pi-shop", title: "lp2EcoStep3Title", description: "lp2EcoStep3Desc" },
  { icon: "pi pi-th-large", title: "lp2EcoStep4Title", description: "lp2EcoStep4Desc" },
];

const LandingEcosystemCycle = () => {
  return (
    <section
      className="full-width py-8"
      style={{ backgroundColor: "var(--extra-soft)" }}
      id="ecossistema"
    >
      <div className="text-center mx-auto" style={{ maxWidth: "680px" }}>
        <div
          className="font-bold text-4xl md:text-5xl title"
          style={{ color: "var(--extra-green)" }}
        >
          {localeText("lp2EcoTitle")}
        </div>
        <div className="text-lg mt-2" style={{ color: "var(--extra-body)" }}>
          {localeText("lp2EcoDescription")}
        </div>
      </div>

      <div className="flex flex-column lg:flex-row align-items-stretch gap-4 mt-5 py-3">
        {steps.map((step, index) => (
          <React.Fragment key={step.title}>
            <div className="flex-1">
              <i
                className={step.icon}
                style={{ color: "var(--extra-green)", fontSize: "1.4rem" }}
              ></i>
              <div
                className="font-semibold text-lg title mt-2"
                style={{ color: "var(--extra-ink)" }}
              >
                {localeText(step.title)}
              </div>
              <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
                {localeText(step.description)}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className="hidden lg:flex align-items-center justify-content-center">
                <i className="pi pi-arrow-right" style={{ color: "var(--extra-body)" }}></i>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default LandingEcosystemCycle;
